<div class="table-container mat-elevation-z2 mx-1 mt-4">
  <div class="row justify-between align-center" style="padding: 1em">
    <!-- Filtros -->
    <app-filtro-tabla
      class="flex-1"
      [datos]="[evento, fecha]"
      [search]="search"
      (onFilterChange)="cambioFiltro($event)"
    />
    <!-- Columnas -->
    <app-column-select
      [(columns)]="columnas"
      [columnNames]="nombreColumnas"
      [saveName]="saveColumnas"
    />
  </div>

  <!-- Pagination -->
  <mat-paginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />

  <!-- Tabla -->
  <mat-table
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortChange($event)"
  >
    <!-- Columna fecha  -->
    <ng-container matColumnDef="fecha">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Fecha de encendido
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Fecha de encendido:</span>
        {{ row.fecha | date: "short" }}
      </mat-cell>
    </ng-container>

    <!-- Columna evento  -->
    <ng-container matColumnDef="evento">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Evento
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Evento:</span>
        {{ row.evento }}
      </mat-cell>
    </ng-container>

    <!-- Columna mensaje  -->
    <ng-container matColumnDef="mensaje">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Mensaje
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Mensaje:</span>
        <span style="text-overflow: ellipsis; max-width: 100%">
          {{ row.mensaje }}
        </span>
      </mat-cell>
    </ng-container>

    <!-- Columna origen  -->
    <ng-container matColumnDef="origen">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Origen
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Origen:</span>
        {{ row.origen }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnas; sticky: true" />
    <mat-row *matRowDef="let row; columns: columnas" />
  </mat-table>

  <!-- Pagination -->
  <mat-paginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />
</div>
